<div id="dashboard-project" class="page-layout simple right-sidebar" fxLayout="row">
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div 
            class="header accent p-24 pb-0" 
            fxLayout="column" 
            fxLayoutAlign="space-between"
        >
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <span 
                    class="mat-display-1 my-0 my-sm-24 welcome-message" 
                    [@animate]="{value:'*',params:{x:'50px'}}">
                    Dashboard Renda Variável Operacional
                </span>
            </div>            
        </div>
        <!-- / HEADER -->

        <div class="content">

            <div dynamicHeight>
                
                <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom [@animateStagger]="{value:'50'}">

                    <!-- Total de CLientes -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px"
                    >
                    
                    <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row"  fxLayoutAlign="space-between center">
                            
                                <div class="h3"> 
                                    <mat-icon class="s-16">person</mat-icon>
                                    Total Clientes
                                </div>

                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                            </div>

                            <div class="p-16 pt-0 line-height-1.75 light-blue-fg" style="font-size: 20px">
                                {{total_clientes}}
                            </div>
                        
                        </div>
                    <!-- Back -->
                    <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>

                            <div class="texto-indicador">
                                Total de Clientes Cadastrados na Plataforma Investimentos
                            </div>
                    </div>
                    <!-- / Back -->
                    </fuse-widget>
                    <!-- / Total de CLientes --> 

                    <!-- Cliente em MRV -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px">
                        
                        <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row"  fxLayoutAlign="space-between center">
                                
                                <div class="h3"> 
                                    <mat-icon class="s-16">person</mat-icon>
                                    Clientes em MRV
                                </div>

                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                            </div>

                            <div class="p-16 pt-0 line-height-1.75 light-blue-fg" style="font-size: 20px">
                                {{qtd_cliente}}
                            </div>
                            
                        </div>
                        <!-- Back -->
                        <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>

                            <div class="texto-indicador">
                                Total de Clientes Cadastrados em MRV
                            </div>
                        </div>
                        <!-- / Back -->
                    </fuse-widget>
                    <!-- / Clientes em MRV --> 
                
                    <!-- Clientes Home Brokers -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px">
                    
                    <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row"  fxLayoutAlign="space-between center">
                            
                                <div class="h3"> 
                                    <mat-icon class="s-16">person</mat-icon>
                                    Clientes Home Brokers
                                </div>

                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                            </div>

                            <div class="p-16 pt-0 line-height-1.75 light-blue-fg" style="font-size: 20px">
                                {{qtd_cliente_home}}
                            </div>
                        
                        </div>
                    <!-- Back -->
                    <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>

                            <div class="texto-indicador">
                                Total de Clientes Home Brokers Importados
                            </div>
                    </div>
                    <!-- / Back -->
                    </fuse-widget>
                    <!-- / Clientes Home Brokers -->

                    <!-- Clientes S/RV -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px">
                        
                    <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row"  fxLayoutAlign="space-between center">
                            
                                <div class="h3"> 
                                    <mat-icon class="s-16">person</mat-icon>
                                    Clientes S/RV
                                </div>

                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                            </div>

                            <div class="p-16 pt-0 line-height-1.75 light-blue-fg" style="font-size: 20px">
                                {{clientes_rv}}
                            </div>
                        
                        </div>
                    <!-- Back -->
                        <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>

                            <div class="texto-indicador">
                                Total de Clientes Cadastrados Sem Operar na Renda Váriavel
                            </div>
                        </div>
                    <!-- / Back -->
                    </fuse-widget>
                    <!-- / Clientes S/RV -->

                    <!-- Total Custódia -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px">
                    
                        <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row"  fxLayoutAlign="space-between center">
                                
                            <div class="h3"> 
                                <mat-icon class="s-16">attach_money</mat-icon>
                                Total Custódia
                            </div>

                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                            </div>

                            <div class="p-16 pt-0 line-height-1.75 light-blue-fg" style="font-size: 16px">
                                R$ {{totalCustodia | number : '1.2-2'}}
                            </div>
                            
                        </div>
                        <!-- Back -->
                        <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>

                            <div class="texto-indicador">
                                Contemplando o valor dos ativos do ultimo pregão (Soma das estratégias: Finaciamento de Opções, SwingTrade e Fiis)
                            </div>
                        </div>
                    <!-- / Back -->
                    </fuse-widget>
                    <!-- / Total Custódia -->                          

                    <!-- Valor de Boletas Efetivadas -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px">
                        
                        <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row"  fxLayoutAlign="space-between center">
                                
                            <div class="h3"> 
                                <mat-icon class="s-16">attach_money</mat-icon>
                                Boletas Efetivada
                            </div>

                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                            </div>

                            <div class="p-16 pt-0 line-height-1.75 light-blue-fg" style="font-size: 16px">
                                R$ {{vlr_boletas | number : '1.2-2'}}
                            </div>
                            
                        </div>
                        <!-- Back -->
                        <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>

                            <div class="texto-indicador">
                                Total Financeiro de boletas efetivadas
                            </div>
                        </div>
                        <!-- / Back -->
                    </fuse-widget>
                    <!-- / Valor de Boletas-->

                    <!-- Valor de Boletas de Finaciamento de Opções -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px">
                        
                        <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row"  fxLayoutAlign="space-between center">
                                
                            <div class="h3"> 
                                <mat-icon class="s-16">attach_money</mat-icon>
                                Boletas Disponivel RV
                            </div>

                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                            </div>

                            <div class="p-16 pt-0 line-height-1.75 light-blue-fg" style="font-size: 16px">
                                R$ {{vlr_boletasFO | number : '1.2-2'}}
                            </div>
                            
                        </div>
                        <!-- Back -->
                        <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>

                            <div class="texto-indicador">
                                Total Financeiro de Boletas de Financiamento 
                                de Opções que não foram efetivadas
                            </div>
                        </div>
                        <!-- / Back -->
                    </fuse-widget>
                    <!-- / Valor de Boletas de Finaciamento de Opções -->        
                    

                    <!-- Total em MRV -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px">
                        
                        <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row"  fxLayoutAlign="space-between center">
                                
                            <div class="h3"> 
                                <mat-icon class="s-16">attach_money</mat-icon>
                                Total em MRV
                            </div>

                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                            </div>

                            <div class="p-16 pt-0 line-height-1.75 light-blue-fg" style="font-size: 16px">
                                R$ {{vlr_total_invest | number : '1.2-2'}}
                            </div>
                            
                        </div>
                        <!-- Back -->
                        <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>

                            <div class="texto-indicador">
                                Total Investido de todos os clientes em MRV
                            </div>
                        </div>
                        <!-- / Back -->
                    </fuse-widget>
                    <!-- / Total em MRV -->

                    <!-- Total Disponivel para Investimentos -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px">
                    
                        <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row"  fxLayoutAlign="space-between center">
                                
                                <div class="h3">Saldo Disponível</div>

                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                            </div>
                            
                            <div 
                                class="p-16 pt-0 line-height-1.75" 
                                (click)="redirectListaDisponivel()" 
                                style="font-size: 16px; cursor: pointer;">
                                <span [ngClass]="{'red-fg':vlt_total_dispo < 0 , 'light-blue-fg': vlt_total_dispo > 0 }">
                                    R$ {{ vlt_total_dispo | number : '1.2-2'}}
                                </span>
                                
                            </div>                            
                            
                        </div>
                        
                        <!-- Back -->
                        <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>

                            <div class="texto-indicador">
                                Total Financeiro Disponivel para investimento.
                                Clique no número para visualizar a lista de clientes
                            </div>
                        </div>
                        <!-- / Back -->
                    </fuse-widget>
                    <!-- / Total Disponivel para Investimentos -->
                    
                    <!-- Clientes com incosistencias -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px"
                        *ngIf="this.user.role_id == 7 || this.user.role_id == 4 || this.user.role_id == 1 || this.user.role_id == 2">
                
                        <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row"  fxLayoutAlign="space-between center">
                                
                                <div class="h3">Clientes com Inconsistências</div>

                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                            </div>
                            
                            <div 
                                class="p-16 pt-0 line-height-1.75 red-fg" 
                                (click)="redirectListaIncosistecias()" 
                                style="font-size: 16px; cursor: pointer;">
                                <span>{{ totalIncosistencias }}</span>
                            </div>                            
                            
                        </div>
                        
                        <!-- Back -->
                        <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>

                            <div class="texto-indicador">
                                Lista com clientes com clientes com possiveis incosistências. 
                                (Quantidade de custódia negativa)
                            </div>
                        </div>
                        <!-- / Back -->
                    </fuse-widget>
                    <!-- / Clientes com incosistencias -->
                    
                    <!-- Corretagem -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px"
                    >
                        
                        <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row" fxLayoutAlign="space-between center">                                        
                                <div class="h3">                               
                                    Corretagem
                                </div>            
                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>            
                            </div>
    
                            <div class="p-16 pt-0 line-height-1.75 light-blue-fg" style="font-size: 16px">
                                R$ {{ vlr_projecao_mrc | number : '1.2-2'}}
                            </div>
                            
                        </div>
                        <!-- Back -->
                        <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>
    
                            <div class="texto-indicador">
                                Valor <b>projetado</b> de receita <b>bruta</b> RV com base nas operações 
                                executadas pelos clientes via RV Prosperidade <b>(Estimativa)</b>
                                Informações em <b>D-2</b>
                            </div>
                        </div>
                        <!-- / Back -->
                    </fuse-widget>
                    <!-- / Corretagem -->


                    <!-- FEE -->
                    <fuse-widget 
                        [@animate]="{value:'*',params:{y:'100%'}}" 
                        class="widget" 
                        fxLayout="column" 
                        fxFlex="100" 
                        fxFlex.gt-xs="50" 
                        fxFlex.gt-md="25"
                        style="height:135px"
                    >
                        
                        <!-- Front -->
                        <div class="fuse-widget-front">
                            <div class="pl-16 pr-8 py-16 h-52" fxLayout="row" fxLayoutAlign="space-between center">                                        
                                <div class="h3">                               
                                    FEE
                                </div>            
                                <button mat-icon-button fuseWidgetToggle aria-label="more">
                                    <mat-icon>more_vert</mat-icon>
                                </button>            
                            </div>
    
                            <div class="p-16 pt-0 line-height-1.75 light-blue-fg" style="font-size: 16px">
                                R$ {{ vlr_projecao_fee_mrc | number : '1.2-2'}}
                            </div>
                            
                        </div>
                        <!-- Back -->
                        <div class="fuse-widget-back p-16 pt-32">
                            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                    aria-label="Flip widget">
                                <mat-icon class="s-16">close</mat-icon>
                            </button>
    
                            <div class="texto-indicador">
                                Valor <b>projetado</b> de receita <b>liquida</b> RV com base nas operações de FEEs
                                executadas de pelos clientes via RV Prosperidade <b>(Estimativa)</b>
                                Informações em <b>D-2</b>
                            </div>
                        </div>
                        <!-- / Back -->
                    </fuse-widget>
                    <!-- / FEE -->
                   

                    <!-- Grafico de Valor Investido em MRV -->
                    <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" fxLayout="row" fxFlex="100" class="widget widget5" *ngIf="this.user.role_id == 7 || this.user.role_id == 4 || this.user.role_id == 1 || this.user.role_id == 2 || this.graficosEscritorio ">

                            <!-- Front -->
                            <div class="fuse-widget-front">

                                <div class="px-16 border-bottom" fxLayout="row wrap"
                                    fxLayoutAlign="space-between center">

                                    <div fxFlex class="py-16 h3">Valor Investido em MRV</div>

                                    <div fxFlex="0 1 auto" class="py-16" fxLayout="row">

                                        <button mat-button class="px-16"
                                            *ngFor="let range of widgets.widget5.ranges | keys"
                                            (click)= "filtraGraficoMrv(range.key)"
                                            [ngClass]="{'accent' : widget5.currentRange == range.key}">
                                            {{range.value}}
                                        </button>

                                    </div>
                                </div>

                                <div fxLayout="row wrap" fxLayoutAlign="start start">

                                    <div class="h-420 my-16" fxLayout="row" fxFlex="100" fxFlex.gt-sm="100">
                                        <ngx-charts-bar-vertical
                                            *fuseIfOnDom
                                            [scheme]="widget5.scheme"
                                            [results]="resultado"
                                            [gradient]="widget5.gradient"
                                            [xAxis]="widget5.xAxis"
                                            [yAxis]="widget5.yAxis"
                                            [legend]="widget5.legend"
                                            [showXAxisLabel]="widget5.showXAxisLabel"
                                            [showYAxisLabel]="widget5.showYAxisLabel"
                                            [xAxisLabel]="widget5.xAxisLabel"
                                            [yAxisLabel]="widget5.yAxisLabel"
                                            (select)="widget5.onSelect($event)">
                                        </ngx-charts-bar-vertical>
                                    </div>

                                </div>
                            </div>
                            <!-- / Front -->

                    </fuse-widget>
                    <!-- / Grafico de Valor Investido em MRV -->

                    <!-- Grafico Top Assessores em MRV -->
                    <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" fxLayout="row" fxFlex="100" class="widget widget5" *ngIf="this.user.role_id != 5">

                        <!-- Front -->
                        <div class="fuse-widget-front">

                            <div class="px-16 border-bottom" fxLayout="row wrap"
                                fxLayoutAlign="space-between center">

                                <div fxFlex class="py-16 h3">Top 10 Volume (R$) Assessores</div>

                                <div fxFlex="0 1 auto" class="py-16" fxLayout="row">
                                    <button mat-button class="px-16"
                                        *ngFor="let range of widgets.widget6.ranges | keys"
                                        (click)= "filtraGraficoAssessor(range.key)"
                                        [ngClass]="{'accent' : widget6.currentRange == range.key}">
                                        {{range.value}}
                                    </button>
                                    
                                </div>
                            </div>

                            <div fxLayout="row wrap" fxLayoutAlign="start start">

                                <div class="h-420 my-16" fxLayout="row" fxFlex="100" fxFlex.gt-sm="100">
                                    <ngx-charts-bar-vertical
                                        *fuseIfOnDom
                                        [scheme]="widget6.scheme"
                                        [results]="resultado_2"
                                        [gradient]="widget6.gradient"
                                        [xAxis]="widget6.xAxis"
                                        [yAxis]="widget6.yAxis"
                                        [legend]="widget6.legend"
                                        [showXAxisLabel]="widget6.showXAxisLabel"
                                        [showYAxisLabel]="widget6.showYAxisLabel"
                                        [xAxisLabel]="widget6.xAxisLabel"
                                        [yAxisLabel]="widget6.yAxisLabel"
                                        (select)="widget6.onSelect($event)">
                                    </ngx-charts-bar-vertical>
                                </div>
                            </div>
                        </div>
                        <!-- / Front -->
                    </fuse-widget>
                    <!-- / Grafico Top Assessores em MRV -->

                    <!-- Graficos de Novos Clientes -->
                    <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100" fxFlex.gt-sm="50" *ngIf="(this.user.role_id == 7 || this.user.role_id == 4 || this.graficosEscritorio ) && exibeGrafico_3">

                        <!-- Front -->
                        <div class="fuse-widget-front">

                            <div class="px-16 py-8 border-bottom" fxLayout="row" fxLayoutAlign="space-between center">
                                <div class="h3">Qtd. Novos Clientes</div>
                                <mat-form-field>
                                    <mat-select 
                                        class="simplified" 
                                        (selectionChange)="filtraTotalClientes()" 
                                        aria-label="Change range" 
                                        [(ngModel)]="widget7.currentRange">
                                        <mat-option *ngFor="let range of widgets.widget7.ranges | keys" [value]="range.key">
                                            {{range.value}}
                                        </mat-option>                                        
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="h-400">
                                <ngx-charts-pie-chart
                                    *fuseIfOnDom
                                    [scheme]="widget7.scheme"
                                    [results]="resultado_3"
                                    [legend]="widget7.showLegend"
                                    [explodeSlices]="widget7.explodeSlices"
                                    [labels]="widget7.labels"
                                    [doughnut]="widget7.doughnut"
                                    [gradient]="widget7.gradient"
                                    (select)="widget7.onSelect($event)">
                                </ngx-charts-pie-chart>
                            </div>

                            <div class="py-8 mh-16 border-top" fxLayout="row wrap" fxLayoutAlign="start center">

                                <div class="py-8 border-right" fxLayout="column" fxLayoutAlign="center center" fxFlex="100" fxFlex.gt-sm="100">
                                    <span class="mat-display-1 mb-0">
                                        {{resultado_3_total}}
                                    </span>
                                    <span class="h4">Total de Novo Clientes</span>
                                </div>

                            </div>

                        </div>
                        <!-- / Front -->

                    </fuse-widget>
                    <!-- / Graficos de Novos Clientes-->
                    
                    <!-- Graficos Custódia Atual -->
                    <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100" fxFlex.gt-sm="50" *ngIf="(this.user.role_id == 7 || this.user.role_id == 4 || this.graficosEscritorio) && exibeGrafico_5">

                        <!-- Front -->
                        <div class="fuse-widget-front">

                            <div class="px-16 py-8 border-bottom" fxLayout="row" fxLayoutAlign="space-between center">
                                <div class="h3">Custódia Atual</div>
                                <mat-form-field>
                                    <mat-select class="simplified" aria-label="Change range" (selectionChange)="filtraCustodiaClientes()" [(ngModel)]="widget9.currentRange">
                                        <mat-option *ngFor="let range of widgets.widget9.ranges | keys" [value]="range.key">
                                            {{range.value}}
                                        </mat-option>                                        
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="h-400">
                                <ngx-charts-pie-chart
                                    *fuseIfOnDom
                                    [scheme]="widget9.scheme"
                                    [results]="resultado_5"
                                    [legend]="widget9.showLegend"
                                    [explodeSlices]="widget9.explodeSlices"
                                    [labels]="widget9.labels"
                                    [doughnut]="widget9.doughnut"
                                    [gradient]="widget9.gradient"
                                    (select)="widget9.onSelect($event)">
                                </ngx-charts-pie-chart>
                            </div>

                            <div class="py-8 mh-16 border-top" fxLayout="row wrap" fxLayoutAlign="start center">

                                <div class="py-8 border-right" fxLayout="column" fxLayoutAlign="center center" fxFlex="100" fxFlex.gt-sm="100">
                                    <span class="mat-display-1 mb-0">
                                    R$ {{resultado_5_total | number : '1.2-2'}}
                                    </span>
                                    <span class="h4">Total de Custódia dos Clientes</span>
                                </div>

                            </div>

                        </div>
                        <!-- / Front -->

                    </fuse-widget>
                    <!-- / Graficos Custódia Atual -->
                </div>
            </div>
         

        </div>
    </div>
</div>
